<template>

  <div style="height: 100%;">

    <pc v-if="isShowPc" />

    <move v-else="isShowMove" />

  </div>

</template>

<script>
import pc from '../index.vue'
import move from './mobileHome.vue'
export default {
  // 引入组件
  components: {
    pc,
    move
  },
  data() {
    return {
      isShowPc: true,
      isShowMove: false
    }
  },
  created() {
    if (this.isMobile()) {
      this.isShowPc = false;
      this.isShowMove = true;
    } else {
      this.isShowPc = true;
      this.isShowMove = false;
    }

  },

  methods: {
    isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      )
      return flag
    }
  }
};
</script>

<style scoped>
.el-tabs {
  background-color: white;
  height: calc(100vh);
  margin-top: 5px;
}

.mainBox {
  padding: 5px;
  margin: 5px;
  height: 90%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Home.vue